export default __webpack_public_path__ + "static/5-interface-a0720fca7de1135c52b0c96e69745329.png";